
import React from 'react';
import { useForm } from 'react-hook-form';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { FormHeader } from './TaskForm/FormHeader';
import { FormFields } from './TaskForm/FormFields';
import { Task } from '@/types/task';

interface AddTaskFormProps {
  onSubmit: (data: any) => void;
  initialData?: Task;
}

type FormValues = {
  title: string;
  description: string;
  hebrewTitle: string;
  hebrewDescription: string;
  selectedDays: string[];
  scheduledHour?: number;
  scheduledMinute?: number;
  coins: number;
};

export const AddTaskForm = ({ onSubmit, initialData }: AddTaskFormProps) => {
  const { register, handleSubmit, watch, setValue } = useForm<FormValues>({
    defaultValues: {
      title: initialData?.title || '',
      description: initialData?.description || '',
      hebrewTitle: initialData?.hebrewTitle || '',
      hebrewDescription: initialData?.hebrewDescription || '',
      selectedDays: initialData?.scheduledDay ? [initialData.scheduledDay] : [],
      scheduledHour: initialData?.scheduledHour,
      scheduledMinute: initialData?.scheduledMinute,
      coins: initialData?.coins || 0,
    }
  });

  const handleFormSubmit = (data: FormValues) => {
    const baseTask = {
      title: data.title,
      description: data.description,
      hebrewTitle: data.hebrewTitle,
      hebrewDescription: data.hebrewDescription,
      scheduledHour: data.scheduledHour ? Number(data.scheduledHour) : undefined,
      scheduledMinute: data.scheduledMinute ? Number(data.scheduledMinute) : undefined,
      coins: Number(data.coins) || 0,
    };

    // If days are selected, create a task for each selected day
    if (data.selectedDays && data.selectedDays.length > 0) {
      // When editing a single task, just update that task
      if (initialData && data.selectedDays.length === 1) {
        onSubmit({
          ...baseTask,
          scheduledDay: data.selectedDays[0],
        });
      } else {
        // For multiple days selected or new task creation, handle each day
        data.selectedDays.forEach(day => {
          onSubmit({
            ...baseTask,
            scheduledDay: day,
          });
        });
      }
    } else {
      // If no days selected, create an unscheduled task
      onSubmit({
        ...baseTask,
        scheduledDay: null,
      });
    }
  };

  return (
    <Card className="p-6 w-full max-w-2xl mx-auto bg-[#222222] border-[#403E43] text-white">
      <form onSubmit={handleSubmit(handleFormSubmit)} className="space-y-6">
        <FormHeader />
        <FormFields
          register={register}
          watch={watch}
          setValue={setValue}
          hebrewTitle={watch('hebrewTitle')}
          hebrewDescription={watch('hebrewDescription')}
        />
        <Button
          type="submit"
          className="w-full bg-cat-primary hover:bg-cat-primary/80"
        >
          {initialData ? 'Update Task' : 'Add Task'}
        </Button>
      </form>
    </Card>
  );
};
